import { c as _c } from "react/compiler-runtime";
import React from "react";
import PrimaryButton from "../utils/button/PrimaryButton";
interface CreateDropSubmitProps {
  readonly submitting: boolean;
  readonly canSubmit: boolean;
  readonly isDropMode: boolean;
  readonly onDrop: () => void;
}
export const CreateDropSubmit: React.FC<CreateDropSubmitProps> = t0 => {
  const $ = _c(8);
  const {
    submitting,
    canSubmit,
    isDropMode,
    onDrop
  } = t0;
  const t1 = !canSubmit;
  const t2 = isDropMode ? "Drop" : "Post";
  let t3;
  if ($[0] !== t2) {
    t3 = <span className="tw-hidden lg:tw-inline">{t2}</span>;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="tw-size-5 lg:tw-hidden"><path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" /></svg>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== onDrop || $[4] !== submitting || $[5] !== t1 || $[6] !== t3) {
    t5 = <PrimaryButton onClicked={onDrop} loading={submitting} disabled={t1} padding="tw-px-2.5 lg:tw-px-3.5 tw-py-3 tw-max-w-[3.875rem]">{t3}{t4}</PrimaryButton>;
    $[3] = onDrop;
    $[4] = submitting;
    $[5] = t1;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};